import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface NavigationGuardOptions {
  isDirty: boolean;
  onNavigationAttempt: (targetPath: string) => void;
}

export const useNavigationGuard = ({ isDirty, onNavigationAttempt }: NavigationGuardOptions) => {
  const location = useLocation();

  useEffect(() => {
    if (!isDirty) return;

    // Intercept link clicks
    const handleLinkClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const link = target.closest('a[href]') as HTMLAnchorElement;

      if (link && link.getAttribute('href')?.startsWith('/')) {
        const href = link.getAttribute('href');
        if (href && href !== location.pathname) {
          event.preventDefault();
          event.stopPropagation();
          onNavigationAttempt(href);
        }
      }
    };

    // Add click listener to document to catch all link clicks
    document.addEventListener('click', handleLinkClick, true);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleLinkClick, true);
    };
  }, [isDirty, location.pathname, onNavigationAttempt]);
};
